import React from 'react';
import BenefitCard from './BenefitCard';

export default function BenefitGrid({items}) {
    return (
        <div className="benefits-grid">
            {items.map((item, index) => (
                <BenefitCard key={index} title={item.title} items={item.short_description} image={item.image_url} />
            ))}
        </div>
    );
}
